import revive_payload_client_4sVQNw7RlN from "/build/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/build/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/build/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/build/node_modules/nuxt/dist/app/plugins/payload.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/build/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import plugin_9jT3W5OS8r from "/build/.nuxt/runtime/plugin.ts";
import plugin_vue3_A0OWXRrUgq from "/build/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/build/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/build/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_kcwR6Qz4dH from "/build/src/modules/lrud/runtime/plugin.ts";
import plugin_WBrTlpHsOa from "/build/src/modules/notification/runtime/plugin.ts";
import plugin_8SbxDRbG6Y from "/build/node_modules/dayjs-nuxt/dist/runtime/plugin.mjs";
import chunk_reload_client_UciE0i6zes from "/build/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import backButton_client_nTf4sBBdRm from "/build/src/plugins/backButton.client.ts";
import sentry_client_KAXFuL2wum from "/build/src/plugins/sentry.client.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  check_outdated_build_client_8vK7RkfGxZ,
  plugin_9jT3W5OS8r,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_kcwR6Qz4dH,
  plugin_WBrTlpHsOa,
  plugin_8SbxDRbG6Y,
  chunk_reload_client_UciE0i6zes,
  backButton_client_nTf4sBBdRm,
  sentry_client_KAXFuL2wum
]